"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

require("element-closest");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _helpers = require("../helpers");

var _OutsideClickWrapper = require("../OutsideClickWrapper");

var _OutsideClickWrapper2 = _interopRequireDefault(_OutsideClickWrapper);

require("./Popover.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultAlignment = "bottom";

var alignTypes = ["top", "topRight", "topLeft", "right", "rightTop", "rightBottom", "bottom", "bottomRight", "bottomLeft", "left", "leftTop", "leftBottom"];

var rootClass = "js-aclui-popover-root";

var Popover = function (_PureComponent) {
  _inherits(Popover, _PureComponent);

  function Popover(props) {
    _classCallCheck(this, Popover);

    var _this = _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

    _this.handleScroll = function () {
      if (_this.$popover) {
        _this.$popover.classList.remove("aclui-popover--is-visible");
        _this.$popover.classList.add("aclui-popover--is-hidden");
        clearTimeout(_this.timeout);
        _this.calculatePosition();
        _this.timeout = setTimeout(function () {
          _this.calculatePosition();
          _this.$popover.classList.add("aclui-popover--is-visible");
          _this.$popover.classList.remove("aclui-popover--is-hidden");
        }, _this.delay);
      }
    };

    _this.handleRefEvent = function ($e) {
      if ($e) {
        _this.$popover = $e;
        _this.assignContainerElement();
        _this.handleOnResizeOnScrollEvent("add", _this.getScrollableElementSource(), ["resize", "scroll"], _this.handleScroll);
        _this.calculatePosition();
      } else {
        _this.handleOnResizeOnScrollEvent("remove", _this.getScrollableElementSource(), ["resize", "scroll"], _this.handleScroll);
      }
    };

    _this.mouseEnterHandler = function (e) {
      _this.props.onMouseEnter(e);
    };

    _this.mouseLeaveHandler = function (e) {
      _this.props.onMouseLeave(e);
    };

    _this.renderArrow = function () {
      if (!_this.props.hasArrow) return null;

      var arrowClasses = (0, _classnames2.default)("aclui-popover__arrow", _this.currentalign && alignTypes.includes(_this.currentalign) ? _this.currentalign : defaultAlignment);

      return _react2.default.createElement(
        "div",
        { className: arrowClasses, "aria-hidden": true },
        _react2.default.createElement(
          "div",
          { className: "aclui-popover__caret" },
          _react2.default.createElement("div", { className: "aclui-popover__caret__top" }),
          _react2.default.createElement("div", { className: "aclui-popover__caret__bottom" })
        ),
        _this.props.hasSonar ? _react2.default.createElement("div", { className: "aclui-popover__sonar" }) : null
      );
    };

    _this.timeout = null;
    _this.delay = 250;
    _this.$popover = null;
    _this.$container = null;
    _this.$parent = null;
    _this.renderByQuery = props.renderByQuery;
    _this.currentalign = props.align;
    return _this;
  }

  _createClass(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.waitToRender) {
        setTimeout(function () {
          _this2.calculatePosition();
        }, this.props.waitToRender);
      } else {
        this.calculatePosition();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.renderByQuery) {
        /**
         * The renderByQuery prop can be either a function or a string and so a
         * comparison to the previous value will not be reliable and so it should
         * be reassigned to this.renderByQuery.
         */
        this.renderByQuery = nextProps.renderByQuery;
      }

      if (this.props.align !== nextProps.align) {
        this.currentalign = nextProps.align;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.show) {
        this.assignContainerElement();
        this.calculatePosition();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleOnResizeOnScrollEvent("remove", this.getScrollableElementSource(), ["resize", "scroll"], this.handleScroll);
    }
  }, {
    key: "getScrollableElementSource",
    value: function getScrollableElementSource() {
      var parentScrollContainer = this.props.parentScrollContainer;

      return parentScrollContainer ? parentScrollContainer() : this.getScrollableElement();
    }
  }, {
    key: "getScrollableElement",
    value: function getScrollableElement() {
      if (this.$container) {
        var $scrollableElement = (0, _helpers.getScrollParent)(this.$container);

        if ($scrollableElement.nodeName.toLowerCase() !== "body") {
          return $scrollableElement;
        }
        return window;
      }
      return window;
    }
  }, {
    key: "handleOnResizeOnScrollEvent",
    value: function handleOnResizeOnScrollEvent(type, $element, eventArray, callback) {
      var events = {
        add: function add() {
          eventArray.forEach(function (event) {
            $element.addEventListener(event, callback);
          });
        },
        remove: function remove() {
          eventArray.forEach(function (event) {
            $element.removeEventListener(event, callback);
          });
        }
      };

      events[type]();
    }

    // we want to calculate the position again until the user stops scrolling

  }, {
    key: "calculatePosition",
    value: function calculatePosition() {
      if (this.$popover) {
        var positionByBoundingClientRect = this.props.positionByBoundingClientRect;

        var rect = positionByBoundingClientRect ? positionByBoundingClientRect() : this.$container.getBoundingClientRect();
        var align = (0, _helpers.alignFixedPositionElement)(this.currentalign, this.$popover, rect, this.props.offsetFromTrigger);
        this.$popover.setAttribute("style", align + " z-index: " + this.props.zIndex + ";");
      }
    }
  }, {
    key: "assignContainerElement",
    value: function assignContainerElement() {
      if (this.renderByQuery) {
        var element = (0, _helpers.getElementBySelectorOrFunction)(this.renderByQuery);
        if (element) {
          this.$container = element;
          return;
        }
        // eslint-disable-next-line
        console.warn("this.props.renderByQuery did not find an element.");
        return;
      }

      this.$container = this.$popover.closest("." + rootClass).children[0];
    }
  }, {
    key: "renderPopover",
    value: function renderPopover() {
      if (this.props.show) {
        var popoverClasses = (0, _classnames2.default)("aclui-popover", this.props.className);

        return _react2.default.createElement(
          _OutsideClickWrapper2.default,
          {
            onOutsideClick: this.props.onOutsideClick,
            canPropagate: this.props.canPropagateOutsideClick
          },
          _react2.default.createElement(
            "div",
            {
              ref: this.handleRefEvent,
              role: this.props.role,
              className: popoverClasses,
              onMouseEnter: this.mouseEnterHandler,
              onMouseLeave: this.mouseLeaveHandler
            },
            this.props.content,
            this.renderArrow()
          )
        );
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var rootClasses = (0, _classnames2.default)(rootClass, this.props.rootClassName);

      return _react2.default.createElement(
        "div",
        { className: rootClasses },
        this.props.children,
        this.renderPopover()
      );
    }
  }]);

  return Popover;
}(_react.PureComponent);

Popover.propTypes = {
  /**
   * Where the popover will be rendered in relation to the trigger (children) or
   * element provided by positionByBoundingClientRect prop
   */
  align: (0, _propTypes.oneOf)(alignTypes),

  /** Determines if the OutsideClickWrapper will allow click events to propagate up the DOM */
  canPropagateOutsideClick: _propTypes.bool,

  /** Children can be empty if the trigger element is passed via props.renderByQuery */
  children: _propTypes.node,

  /** Custom class name added to the actual popover element */
  className: _propTypes.string,

  /** The content to be rendered inside the Popover */
  content: _propTypes.node.isRequired,

  /** If the Popover's arrow should be shown or not */
  hasArrow: _propTypes.bool,

  /** If the Popover's sonar should be shown or not */
  hasSonar: _propTypes.bool,

  /** Distance (in px) between edge of Popover and trigger element */
  offsetFromTrigger: _propTypes.number,

  /** Callback function called when the mouse cursor enters the boundaries of the trigger element */

  onMouseEnter: _propTypes.func,

  /** Callback function called when the mouse cursor exits the boundaries of the trigger element */

  onMouseLeave: _propTypes.func,

  /** Callback function called when a click event is caught by OutsideClickWrapper */
  onOutsideClick: _propTypes.func,

  /**
   * By default the Popover will try to get the nearest scrollable parent element by
   * using the getScrollParent() function. When a layout grows in height dynamically,
   * this function can be used to set a specific scrollable parent on initialization.
   */
  parentScrollContainer: _propTypes.func,

  /**
   * Provides a way to position the Popover manually instead of the default method:
   * this.$container.getBoundingClientRect().
   * Note: This function should return a DOMRect object created by getBoundingClientRect()
   */
  positionByBoundingClientRect: _propTypes.func,

  /**
   * A query selector for a trigger element to attach the Popover to that already
   * exists in the DOM, such as with the GuidedTour component.
   * Example: () => document.querySelector('.your-selector')
   */
  renderByQuery: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]),

  /**
   * Accessibility role for root popover div element
   */
  role: _propTypes.string,

  /**
   * Custom class name added to the root wrapper element that contains the trigger, popover
   * and OutsideClickWrapper elements
   */
  rootClassName: _propTypes.string,

  /** To control the visibility of the popover */
  show: _propTypes.bool,

  /**
   * A delay (in ms) to wait for the browser to render the content and styling which
   * can have an impact on the positioning calculations.
   */
  waitToRender: _propTypes.number,

  /** CSS z-index value of the popover */
  zIndex: _propTypes.number
};

Popover.defaultProps = {
  align: "bottom",
  canPropagateOutsideClick: true,
  children: null,
  className: null,
  hasArrow: true,
  hasSonar: false,
  offsetFromTrigger: 12,
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onOutsideClick: function onOutsideClick() {},
  parentScrollContainer: null,
  positionByBoundingClientRect: null,
  renderByQuery: null,
  role: null,
  rootClassName: null,
  show: false,
  waitToRender: 0,
  zIndex: 302 // legacy value currently used in some modules [workshop]
};

exports.default = Popover;